import axios from 'axios'

// Create axios instance with default config
const instance = axios.create({
  baseURL: process.env.VUE_APP_API_URL || '',
  timeout: 10000
})

// 로그인 직후 세션 설정 시간을 추적 (로그인 직후 일정 시간 동안은 401을 세션 만료로 처리하지 않음)
let lastLoginTime = null
const LOGIN_GRACE_PERIOD = 5000 // 5초

// 로그인 성공 시점 기록
window.addEventListener('user-logged-in', () => {
  lastLoginTime = Date.now()
})

// Add request interceptor
instance.interceptors.request.use(
  config => {
    // Emit event for session renewal
    window.dispatchEvent(new CustomEvent('session-activity'))

    const url = config.url || ''

    // Block dangerous schemes and absolute URLs to prevent SSRF and baseURL bypass
    const isAbsolute = /^[a-zA-Z][a-zA-Z0-9+.-]*:/.test(url) || url.startsWith('//')
    const hasDisallowedScheme = /^data:|^file:/i.test(url)

    if (hasDisallowedScheme || isAbsolute) {
      return Promise.reject(new Error('Unsafe URL rejected'))
    }

    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// Add response interceptor
instance.interceptors.response.use(
  response => {
    // Check if response contains session lifetime in headers
    const sessionLifetime = response.headers['x-session-lifetime']
    if (sessionLifetime) {
      window.dispatchEvent(new CustomEvent('session-renewed', {
        detail: { sessionLifetime: parseInt(sessionLifetime) }
      }))
    }
    return response
  },
  error => {
    // Handle 401 Unauthorized - session expired
    if (error.response && error.response.status === 401) {
      const currentPath = window.location.pathname
      const isAuthPage = currentPath.includes('/auth') || currentPath.includes('/authentication')
      
      // 로그인 페이지에서는 세션 만료 이벤트 발생하지 않음
      if (isAuthPage) {
        return Promise.reject(error)
      }
      
      // 특정 엔드포인트는 인증이 필요 없거나 401이 정상 응답일 수 있음
      const requestUrl = (error.config && error.config.url) || ''
      const isPublicEndpoint = 
        requestUrl.includes('/api/user/') ||  // 사용자 정보 확인 (로그인 전 401은 정상)
        requestUrl.includes('/api/info/') ||  // 서버 정보 (인증 불필요)
        requestUrl.includes('/api/healthcheck') // 헬스체크 (인증 불필요)
      
      // 공개 엔드포인트가 아니고, 인증 페이지가 아닐 때만 세션 만료 이벤트 발생
      if (!isPublicEndpoint) {
        // 로그인 직후 일정 시간 동안은 401을 세션 만료로 처리하지 않음
        const timeSinceLogin = lastLoginTime ? Date.now() - lastLoginTime : Infinity
        const isWithinGracePeriod = timeSinceLogin < LOGIN_GRACE_PERIOD
        
        if (!isWithinGracePeriod) {
          // 약간의 지연을 두어 Vuex store 상태가 업데이트될 시간을 줌
          setTimeout(() => {
            window.dispatchEvent(new CustomEvent('session-expired'))
          }, 100)
        }
      }
    }
    return Promise.reject(error)
  }
)

export default instance